import jQuery from 'jquery';
import {setWindowBusy} from 'MyAccount/ViewDesigns/redux/modules/general';
import safeStore from 'App/safeStore';
import _ from 'lodash';
import Promise from 'bluebird';
let ajaxInProgressCount = 0;

export function wrapAjax(func, {windowBusy = true, abortPreviousRequests = false} = {}) {
  function wrappedAjaxFunc(...args) {
    if (abortPreviousRequests && this.lastPromise) {
      this.lastPromise.cancel();
      this.lastPromise = null;
    }
    const ignoreWindowBusy = _.get(_.last(args), 'windowBusy') === false || !windowBusy;
    if (!ignoreWindowBusy) {
      safeStore().dispatch(setWindowBusy(true));
      ajaxInProgressCount++;
    }
    const promise = Promise.resolve(func(...args));
    if (abortPreviousRequests) {
      this.lastPromise = promise;
    }
    const callback = () => {
      if (!ignoreWindowBusy) {
        ajaxInProgressCount -= 1;
        if (ajaxInProgressCount === 0) {
          safeStore().dispatch(setWindowBusy(false));
        }
      }
    };
    promise.finally(callback);
    return promise;
  }
  return wrappedAjaxFunc.bind(wrappedAjaxFunc);
}

export const setPreference = wrapAjax((item, value) => {
  return jQuery
    .ajax({
      method: 'POST',
      url:
        '/application/account-page/set-preference?' +
        jQuery.param({
          item: item,
          value: value,
        }),
    })
    .fail(console.error.bind(console, 'Set Preference'));
});

export const setTemplateTagSetId = id => {
  return jQuery
    .ajax({
      method: 'POST',
      url:
        '/application/account-page/set-template-tag-set?' +
        jQuery.param({
          id,
        }),
    })
    .fail(console.error.bind(console, 'setTemplateTagSetId'));
};

export const disconnectEbayAccount = UserID => {
  return jQuery
    .ajax({
      method: 'POST',
      url:
        '/application/account-page/disconnect-ebay-account?' +
        jQuery.param({
          UserID,
        }),
    })
    .fail(console.error.bind(console, 'disconnectEbayAccount'));
};

export const getEbayAccounts = () => {
  return jQuery
    .ajax({
      method: 'POST',
      url: '/application/account-page/get-ebay-accounts',
    })
    .fail(console.error.bind(console, 'getEbayAccounts'));
};

export const changeBillingPeriod = wrapAjax(toBillingPeriod => {
  return jQuery
    .ajax({
      method: 'POST',
      url: `/application/account-page/change-billing-period`,
      data: {
        toBillingPeriod,
      },
    })
    .fail(console.error.bind(console, 'changeBillingPeriod'));
});

export const changePlan = wrapAjax((toPlanId, toBillingPeriod = null) => {
  return jQuery
    .ajax({
      method: 'POST',
      url: `/application/account-page/change-plan`,
      data: {
        toPlanId,
        toBillingPeriod,
      },
    })
    .fail(console.error.bind(console, 'changePlan'));
});

export const retryPayment = wrapAjax(() => {
  return jQuery
    .ajax({
      method: 'POST',
      url: `/application/account-page/retry-payment`,
    })
    .fail(console.error.bind(console, 'retryPayment'));
});

export const updateProfile = wrapAjax(data => {
  return jQuery
    .ajax({
      method: 'POST',
      url: `/application/account-page/update-profile`,
      data,
    })
    .fail(console.error.bind(console, 'changeEmail'));
});

export const changePassword = wrapAjax((password, newPassword) => {
  return jQuery
    .ajax({
      method: 'POST',
      url: `/application/account-page/change-password`,
      data: {
        password,
        newPassword,
      },
    })
    .fail(console.error.bind(console, 'changePassword'));
});

export const sendInvitationEmail = data => {
  return jQuery
    .ajax({
      method: 'POST',
      url: `/application/account-page/send-invitation-email`,
      data: {
        data,
      },
    })
    .fail(console.error.bind(console, 'sendInvitationEmail'));
};

export const startFreeTrial = () => {
  return jQuery
    .ajax({
      method: 'POST',
      url: '/application/account-page/start-trial',
    })
    .fail(console.error.bind(console, 'startFreeTrial'));
};

export const editPaidFeatures = wrapAjax((eventPropertyName, paidFeatureType, activate) => {
  return jQuery
    .ajax({
      method: 'POST',
      url: '/application/account-page/edit-paid-feature',
      data: {
        eventPropertyName: eventPropertyName,
        paidFeatureType: paidFeatureType,
        activate: activate,
      },
    })
    .fail(console.error.bind(console, 'editPaidFeatures'));
});

export const getInvoices = () => {
  return jQuery
    .ajax({
      method: 'POST',
      url: `/application/account-page/get-invoices`,
    })
    .fail(console.error.bind(console, 'getInvoices'));
};
